import { IconProps } from '.';
const CompassIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="27"
      height="33"
      viewBox="0 0 27 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <g id="compass">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2501 9.33464C18.2501 6.31094 16.1029 3.78875 13.2501 3.20966V0.167969H10.7501V3.20966C7.89728 3.78875 5.75008 6.31094 5.75008 9.33464C5.75008 11.2114 6.57726 12.8949 7.88691 14.0405L1.06845 29.0411C0.497103 30.2981 1.0529 31.7802 2.30985 32.3516L6.61024 22.8907C8.27752 23.5537 10.0954 23.918 11.9963 23.918C14.0309 23.918 15.9683 23.5013 17.7276 22.7486L22.5505 32.3944C23.7854 31.7769 24.286 30.2752 23.6685 29.0403L19.9337 21.5707C23.9341 18.9704 26.5796 14.4614 26.5796 9.33463H24.0796C24.0796 13.4818 21.9904 17.141 18.8069 19.3171L16.1517 14.0066C17.4391 12.8618 18.2501 11.1929 18.2501 9.33464ZM13.9847 15.2629C13.3612 15.4716 12.6938 15.5846 12.0001 15.5846C11.3263 15.5846 10.6774 15.478 10.0693 15.2807L7.64619 20.6116C8.99501 21.1323 10.4613 21.418 11.9963 21.418C13.629 21.418 15.1861 21.0941 16.6069 20.5072L13.9847 15.2629ZM12.0001 5.58464C9.92902 5.58464 8.25008 7.26357 8.25008 9.33464C8.25008 11.4057 9.92902 13.0846 12.0001 13.0846C14.0712 13.0846 15.7501 11.4057 15.7501 9.33464C15.7501 7.26357 14.0712 5.58464 12.0001 5.58464Z"
          fill={color || '#BABA04'}
        />
      </g>
    </svg>
  );
};

export default CompassIcon;
